export default __webpack_public_path__ + "locales/en/ChangePhoneDialog.json?hash=005a7fc0b1f3ec51dae500e360f4f4f7";